import { render } from "./LoginSkin.vue?vue&type=template&id=be9e81ba&scoped=true"
const script = {}

import "./LoginSkin.vue?vue&type=style&index=0&id=be9e81ba&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be9e81ba"]])

export default __exports__